exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "canvas{\r\n\twidth:70%;\r\n\tmargin: 20px auto;\r\n  \tdisplay: block;\r\n  \tborder: 1px solid black;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/css/custom.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/custom.css
// module chunks = styles